import { IPerfEvent, IPerfManager } from '@ms/1ds-core-js';
import { IStatsCallbacks } from './OneDSSink';
import { EventBatchNotificationReason } from '@ms/1ds-post-js/dist-esm/src/DataModels';

// For the duration of sendBatches.
const SEND_BATCHES_EVENT = 'HttpManager:_sendBatches';
// For the number of events successfully sent
const SEND_BATCHES_NOTIFICATION_EVENT = 'HttpManager:_sendBatchesNotification';

export class PerfEvent implements IPerfEvent {
  /**
   * The name of the event
   */
  name: string;

  /**
   * The start time of the event in ms
   */
  start: number;

  /**
   * The included payload of the event
   */
  payload: any;

  isAsync: boolean;

  /**
   * Identifies the total time spent for this event, including the time spent for child events
   */
  time?: number;

  /**
   * Identifies the exclusive time spent in for this event (not including child events)
   */
  exTime?: number;

  /**
   * Identifies whether this event is a child event of a parent
   */
  isChildEvt(): boolean {
    return false;
  }

  constructor(name: string, payload: any, isAsync?: boolean) {
    this.start = Date.now();
    this.name = name;
    this.isAsync = isAsync === true ? true : false;
    this.payload = payload;
  }

  complete(): void {
    this.time = Date.now() - this.start;
    this.exTime = this.time;
  }
}

export class PerfManager implements IPerfManager {
  private _callbacks: IStatsCallbacks;

  constructor(callbacks: IStatsCallbacks) {
    this._callbacks = callbacks;
  }

  create(src: string, payload?: any, isAsync?: boolean): IPerfEvent {
    if (src === SEND_BATCHES_EVENT || src === SEND_BATCHES_NOTIFICATION_EVENT) {
      let evt: IPerfEvent = new PerfEvent(src, payload, isAsync);

      return evt;
    }
    return (null as any) as IPerfEvent;
  }

  fire(perfEvent: IPerfEvent) {
    if (perfEvent) {
      perfEvent.complete();
    }

    if (this._callbacks) {
      switch (perfEvent.name) {
        case SEND_BATCHES_EVENT:
          this.handleSendBatches(perfEvent);
          break;
        case SEND_BATCHES_NOTIFICATION_EVENT:
          this.handleSendBatchesNotification(perfEvent);
          break;
      }
    }
  }

  setCtx(_key: string, _value: any): void {}

  getCtx(_key: string): any {}

  handleSendBatches(perfEvent: IPerfEvent) {
    if (this._callbacks.requestProcessingStats) {
      // We just want to know how long SEND_BATCHES took.
      // It might not send all the events in its batch - see the notification for the actual number.
      // Also, there is currently a bug in its payload() callback where it doesn't
      // actually return the payload. https://msazure.visualstudio.com/One/_workitems/edit/7984398
      this._callbacks.requestProcessingStats(perfEvent.time || 0, 0);
    }
  }

  handleSendBatchesNotification(perfEvent: IPerfEvent) {
    if (this._callbacks.requestProcessingStats && perfEvent.payload) {
      let payload = perfEvent.payload();
      if (
        payload.batches &&
        payload.reason &&
        // SEND_BATCHES_NOTIFICATION_EVENT fires on both Sending and Success; we just want the Sending event
        payload.reason >= EventBatchNotificationReason.SendingUndefined &&
        payload.reason <= EventBatchNotificationReason.SendingEventMax
      ) {
        let numBatches = 0;
        for (let index in payload.batches) {
          numBatches += payload.batches[index].evts.length;
        }
        // We don't care how long it's taken so far; the SEND_BATCHES contains the relevant timing info
        this._callbacks.requestProcessingStats(0, numBatches);
      }
    }
  }
}
